import React, { useMemo, useEffect } from "react";
import { LoadingSpinner, TableBase } from "@velaro/velaro-component-lib";
import useChatWindows from "@/hooks/useChatWindows";
import NoDesignsAvailable from "./NoDesignsAvailable";
import CreateModal from "./CreateModal";
import ActionBar from "./ActionBar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { set } from "lodash";
import DeleteModal from "./DeleteModal";

const columns = [
  { label: "Name", accessor: "name" },
  { label: "Created By", accessor: "createdByUserName" },
  { label: "Updated", accessor: "updateTimestamp" },
  { label: "Action", accessor: "action", disableSort: true }
];

export default function ChatWindow() {
  const [showCreateModal, setShowCreateModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState<number>(0);
  const { chatWindows, loading, createChatWindow, saving, deleteChatWindow } =
    useChatWindows();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("create") === "true") {
      setShowCreateModal(true);
      searchParams.delete("create");
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  async function handleCreate(name: string) {
    const newChatWindow = await createChatWindow(name);
    if (newChatWindow) {
      setShowCreateModal(false);
      navigate(`/chat_window/${newChatWindow.id}`);
    }
  }

  function handleDelete() {
    deleteChatWindow(deleteId);
    setShowDeleteModal(false);
  }

  const tableData = useMemo(() => {
    return chatWindows.map((window) => ({
      name: window.name,
      createdByUserName: window.createdByUserName,
      updateTimestamp: new Date(window.updateTimestamp).toLocaleDateString(
        "en-US",
        { year: "numeric", month: "2-digit", day: "2-digit" }
      ),
      action: (
        <ActionBar
          onEdit={() => navigate(`/chat_window/${window.id}`)}
          onCopy={() => {}}
          onDelete={() => {
            setShowDeleteModal(true);
            setDeleteId(window.id);
          }}
        />
      )
    }));
  }, [chatWindows, navigate]);

  if (loading) return <LoadingSpinner />;

  if (chatWindows.length === 0) {
    return (
      <NoDesignsAvailable
        setShowCreateModal={setShowCreateModal}
        onCreate={handleCreate}
        showCreateModal={showCreateModal}
        saving={saving}
      />
    );
  }

  return (
    <div>
      <TableBase columns={columns} data={tableData} />
      {showCreateModal && (
        <CreateModal
          show={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onCreate={handleCreate}
          saving={saving}
        />
      )}
      {showDeleteModal && (
        <DeleteModal
          onClose={() => setShowDeleteModal(false)}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
}
